import React from 'react';
import { MobileView } from 'react-device-detect';
import styles from '../../styles/views/components/MobileWarning.module.scss';

const MobileWarning = () => (
  <MobileView viewClassName={styles.container}>
    <div className={styles.content}>
      <img src="src/client/assets/warning-mobile.svg" alt="page is not available" />
      <p className={styles.title}>Sorry, this page is not available on mobile!</p>
      <p>Please try on your laptop or desktop</p>
    </div>
  </MobileView>

);

export default MobileWarning;
